import { conditionToDsl } from '@platform/core/lib/filterDsl';
import type { IModuleDefinition, IRecordListParams } from '@platform/core/types';
import { useAllRecords } from '@platform/engine/insights/useAllRecords';
import { useGetStatsQuery } from '@platform/state/api';
import type { DesignSectionKey } from './DesignSectionKey';
import { designCountsOf } from './designCounts';
import { analysisModuleKey, kindField, moduleField } from './designSections';
import { JOURNEY_KIND } from './journeyCodes';
import { journeyCountOf } from './journeyCount';
import { modelCountOf } from './modelCount';
import { useAnalysisSource } from './useAnalysisSource';

/** Усі наскрізні шляхи простору (прототип рахує їх серед усіх записів аналізу). */
const JOURNEYS: IRecordListParams = { filter: conditionToDsl({ field: kindField, op: 'eq', values: [JOURNEY_KIND] }) };

/**
 * Лічильники пунктів групи «Проєктування» лівого меню модуля (прототип v4 mdItems: «Функції 6 · Мотивація 3 · Зацікавлені сторони 2 ·
 * Шляхи користувачів 1 · Сценарії використання 2 · Вимоги 7 · Модель даних 7»): статистика записів бізнес-аналізу модуля за видом;
 * шляхи, чий опис згадує англійську назву модуля (journeyCountOf); основна сутність і сутності прототипу (modelCountOf). Записи аналізу —
 * з простору-джерела (useAnalysisSource: поточний або перший інший з аналізом). Undefined — ще вантажиться. Рендер — engine/menu.
 */
export function useDesignCounts(ws: string, module: IModuleDefinition | undefined): Record<DesignSectionKey, number | undefined> {
  const name = module?.module.name.en ?? module?.module.key ?? '';
  const src = useAnalysisSource(ws, !module);
  const skip = !src || !module;
  const byKind = useGetStatsQuery({ ws: src ?? '', rt: analysisModuleKey, by: kindField, params: { filter: conditionToDsl({ field: moduleField, op: 'eq', values: [name] }) } }, { skip });
  const journeys = useAllRecords(src ?? '', analysisModuleKey, JOURNEYS, 1000, skip);
  const pending = skip || (journeys.isLoading && journeys.records.length === 0);
  return designCountsOf(byKind.data?.buckets, pending ? undefined : journeyCountOf(journeys.records, name), module ? modelCountOf(module) : 0);
}
